import { Injectable } from '@angular/core';
import { Http, Response , Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { IQuanLyYeuCau } from './dm-quan-ly-yeu-cau';

@Injectable()
export class QuanLyYeuCauService {
    constructor(private http: Http) {
     }
   
    GetList(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetList', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }
    XuatExcel(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/XuatExcelDSYeuCau', JSON.stringify(data), {  headers: headers, responseType: ResponseContentType.ArrayBuffer }).map(resp => resp.arrayBuffer());
    }
    XuatWord(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/XuatDocDSYeuCau', JSON.stringify(data), {  headers: headers, responseType: ResponseContentType.ArrayBuffer }).map(resp => resp.arrayBuffer());
    }
    GetListId(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListId', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }
    
    GetListSanPham(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListSP', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }
    GetListSanPham1(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListSP1', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }
    GetListNhomSPTheoCQ(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListNhomSPTheoCoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }
    GetListNhomSPTheoCQ1(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListNhomSPTheoCoQuan1', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }
    GetListThietBi(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListThietBi', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }

    GetListLoaiThietBi(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListLoaiThietBi', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }
    GetListLoaiThietBiDV(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListLoaiThietBiTheoDV', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }
    GetListDSKhachHang(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetDSKhachHang', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }

    GetListQuanHuyenYC(item){
      let headers = new Headers();       
      headers.append("Content-Type", "application/json;charset=utf-8");        
      headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
      let data = item;
      return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListQuanHuyenYC', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    GetListPhuongXaYC(item){
      let headers = new Headers();       
      headers.append("Content-Type", "application/json;charset=utf-8");        
      headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
      let data = item;
      return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListPhuongXaYC', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    GetListMucDo(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListMucDo',JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }

    GetListMucDoAll(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListMucDoAll',JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }

    GetListLoaiYeuCau(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListLoaiYeuCau', JSON.stringify(data), { headers: headers }).map(resp => resp.json());     
    }

    GetListTrangThai(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetListTrangThai', JSON.stringify(data), { headers: headers }).map(resp => resp.json());     
    }

    SaveYeuCau(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/Save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    SaveYeuCauNew(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/SaveNew', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    SendSMS(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/SendSMSYeuCau', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    DeleteYeuCau(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/Delete', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    
    DeleteFile(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/DeleteFile', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

     DeleteKhachHang(item:IQuanLyYeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/DeleteKhachHang', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    SaveUploadFile(formData:FormData){
    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));    
    return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/UploadFile', formData, { headers: headers }).map(resp => resp.json());
    }

    LoadDSFile(item:IQuanLyYeuCau){
      let headers = new Headers();       
      headers.append("Content-Type", "application/json;charset=utf-8");        
      headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
      let data = item;
      return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/GetDSFile', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
     DownloadFile(filename) {
      let headers = new Headers();
      headers.append("Content-Type", "application/json;charset=utf-8");
      headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
      return this.http.get(Config.apiUrl + 'DMXuLyYeuCau/DownloadFile?filename=' + filename, { headers: headers, responseType: ResponseContentType.ArrayBuffer }).map(
          resp =>
              resp.arrayBuffer());
    }
    DeleteFileServer(filename) {
      let headers = new Headers();
      headers.append("Content-Type", "application/json;charset=utf-8");
      headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
      return this.http.get(Config.apiUrl + 'DMXuLyYeuCau/DeleteFileServer?filename=' + filename, { headers: headers }).map(resp => resp.json());
    }
    DocFileExcel(formData:FormData){
    let headers = new Headers();
    headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));    
    return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/InsertKhachHang', formData, { headers: headers }).map(resp => resp.json());
    }
    ds_loaiyeucaudoitong(IdLoai, IdDoiTuong, NangCap) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {IdLoai:IdLoai, IdDoiTuong:IdDoiTuong, NangCap: NangCap};
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/ds_loaiyeucaudoituong', JSON.stringify(data), { headers: headers }).map(resp => resp.json());     
    }
    DanhSach_KetQuaXuLy(YeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = YeuCau;        
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/DanhSach_KetQuaXuLyBuoc', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Check_ChuyenBuocYeuCau(YeuCau) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = YeuCau;
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/Check_ChuyenBuocYeuCau', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    ds_hanghoivien(){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/ds_hanghoivien', JSON.stringify(data), { headers: headers }).map(resp => resp.json());  
    }
    ds_dohailong(){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/ds_dohailong', JSON.stringify(data), { headers: headers }).map(resp => resp.json());  
    }
    ds_linhvucchung(idcha){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdCha:idcha
        };
        return this.http.post(Config.apiUrl + 'DMXuLyYeuCau/ds_linhvucchung', JSON.stringify(data), { headers: headers }).map(resp => resp.json());  
    }
    ds_DiaDanhCCOS(){
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'APICOSS/GetdsTinhThanh', { headers: headers }).map(resp => resp.json());        
    }
}
                       


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/xu-ly/dm-quan-ly-yeu-cau/dm-quan-ly-yeu-cau.service.ts